import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

export default class Main {
  constructor() {
    this.init();
  }
  init() {
    this.onScroll();
    this.badgeHide();
  }

  onScroll() {
    const revealElm = [...document.querySelectorAll(".js-scrollreveal")];

    revealElm.forEach((el) => {
      ScrollTrigger.create({
        trigger: el,
        start: "top 90%",
        //markers: true,
        onEnter: () => {
          el.classList.add("-reveal");
        },
      });
    });
  }

  badgeHide() {
    //バッジを隠す
    const badge = document.querySelector(".js-badge");

    window.addEventListener("scroll", () => {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 0) {
        badge.classList.add("-off");
        badge.classList.remove("-on");
      } else {
        badge.classList.remove("-off");
        badge.classList.add("-on");
      }
    });
  }
}
